import React from 'react'
import {
    CircularProgress,
    Container,
    FormControl,
    TextField,
    Checkbox,
    Modal,
    Fade,
    FormControlLabel,
    Typography,
    Button,
    Grid
} from "@material-ui/core";
import format from "date-fns/format";
import ruLocale from "date-fns/locale/ru";
import MaterialUiPhoneNumber from "material-ui-phone-number";
import {BookingNotAvailable} from "../not-available";
import {BookingHeader} from "../../shared/header";
import {BlackListModal} from "../../shared/blacklist_modal";
import {inject, observer} from "mobx-react";
import Error404 from "../../shared/404";
import {AuthButtonsBlock} from '../../shared/auth_buttons_block';
import {SnackBarAlert} from "../../shared/snackbar";
import {SmsModal} from "../../shared/sms_modal";
import EquipmentSelection from "../equipment/EquipmentSelection";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import EveningIcon from '../../../resources/icons/evening-icon.svg';
import MorningIcon from '../../../resources/icons/morning-icon.svg';
import DayIcon from '../../../resources/icons/day-icon.svg';
import NightIcon from '../../../resources/icons/night-icon.svg';
import WhatshotOutlinedIcon from '@material-ui/icons/WhatshotOutlined';

const dayPartIcons = {
    night: NightIcon,
    morning: MorningIcon,
    day: DayIcon,
    evening: EveningIcon,
};

const BookingRoomPageIndex = inject('bookingPageStore')(observer(({bookingPageStore}) => {
    bookingPageStore.load();
    if (bookingPageStore.bookingServiceType === 'muztorg') {
        document.body.style.backgroundColor = "transparent";
        document.getElementById('root').style.backgroundColor = "transparent";
    }

    const slotPicker = bookingPageStore.slotPicker || {dates: [], groups: []};
    const slotPickerDates = slotPicker.dates || [];
    const slotPickerGroups = slotPicker.groups || [];
    const selectedDateLabel = bookingPageStore.selectedDate
        ? format(bookingPageStore.selectedDate, "eeeeee, d MMMM", {locale: ruLocale}).replace(/./, m => m.toUpperCase())
        : '';
    const canShiftBackward = !slotPickerDates.some((dateCard) => dateCard.is_today);
    const hasSelectedDate = Boolean(bookingPageStore.selectedDate);
    const isSpecialDate = (dateCard) => dateCard.is_holiday || dateCard.weekday_short === 'сб' || dateCard.weekday_short === 'вс';

    const renderDayPartIcon = (groupId) => {
        const iconSrc = dayPartIcons[groupId] || EveningIcon;
        return <img src={iconSrc} alt="" className="booking-slot-group-title-icon-image"/>;
    };

    const isSlotSelected = (slotIndex) => bookingPageStore.selectedFromIndex !== null
        && bookingPageStore.selectedToIndex !== null
        && slotIndex >= bookingPageStore.selectedFromIndex
        && slotIndex <= bookingPageStore.selectedToIndex;

    return (
        bookingPageStore.is404 ? <Error404 hideBackground={bookingPageStore.bookingServiceType === 'muztorg'}/> :
            <Container className="booking-page">
                {bookingPageStore.loadingFirst ?
                    <CircularProgress color="secondary" className="loader"/> :
                    <div>
                        {bookingPageStore.room.booking_enabled ?
                            <div>
                                <BookingHeader
                                    additionalMetrikaId={bookingPageStore.yandex_metrika_id}
                                    buttonText={'История заказов'}
                                    buttonCallback={bookingPageStore.clickHistoryButton}
                                    appUrlSuffix={bookingPageStore.room ? bookingPageStore.room.header_utm_suffix : ''}
                                    backButtonUrl={bookingPageStore.room ? bookingPageStore.room.studio_url : ''}
                                    backButtonText={bookingPageStore.bookingServiceType === 'muztorg' ? 'Вернуться к списку комнат' : 'Назад'}
                                    useLogoUrl={bookingPageStore.bookingServiceType !== 'muztorg'}
                                />
                                <div className="booking">
                                    <div className="room-info">
                                        <div className="room-poster">
                                            <img alt="poster" className="room-poster-image full-width"
                                                 src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane/' : '') + bookingPageStore.room.poster}/>
                                        </div>
                                        <h3 className="room-title full-width">
                                            {bookingPageStore.room.name}
                                        </h3>
                                        <div className="room-description">
                                            {bookingPageStore.room.description}
                                        </div>
                                    </div>
                                    <div className="slots">
                                        <div className="studio-title">
                                            <div>
                                                <div className="studio-name">{bookingPageStore.room.studio}</div>
                                                <div className="room-name">{bookingPageStore.room.name}</div>
                                            </div>
                                        </div>
                                        {
                                            bookingPageStore.banner ?
                                                <div className="booking-banner">
                                                    <a href={bookingPageStore.banner.target_url} target="_blank"
                                                       rel="noopener noreferrer">
                                                        <img
                                                            src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + bookingPageStore.banner.image_url}
                                                            alt="banner"/>
                                                    </a>
                                                </div>
                                                : ''
                                        }
                                        {
                                            bookingPageStore.schedules.length > 1 ?
                                                <div className="schedule-list full-width">
                                                    {bookingPageStore.schedules.map((el, key) =>
                                                        <div
                                                            onClick={bookingPageStore.handleChangeSchedule.bind(this, el.id)}
                                                            className=
                                                                {'one-schedule '
                                                                    + (bookingPageStore.scheduleId === el.id ? 'active' : 'not-active')
                                                                    + (bookingPageStore.bookingServiceType === 'muztorg' ? ' blue-active' : '')
                                                                }
                                                            key={key}>
                                                            {el.title}
                                                        </div>
                                                    )}
                                                </div>
                                                : ''
                                        }
                                        <br/>
                                        {bookingPageStore.hot_offer ?
                                            <div className="booking-hot-banner booking-hot-banner-inline">
                                                <div className="booking-hot-banner-copy">
                                                    <div className="booking-hot-banner-title">Успей взять!</div>
                                                    <div className="booking-hot-banner-content">{bookingPageStore.hot_offer.text}</div>
                                                </div>
                                                <div className="booking-hot-banner-icon">
                                                    <WhatshotOutlinedIcon fontSize="inherit"/>
                                                </div>
                                            </div>
                                            : ''}
                                        <section className="booking-slot-picker">
                                            <div className="booking-slot-picker-header">
                                                <Typography variant="h6" className="booking-slot-picker-title">
                                                    Выберите дату и время
                                                </Typography>
                                            </div>
                                            <div className="booking-slot-picker-month-row">
                                                <Typography variant="h6" className="booking-slot-picker-month">
                                                    {slotPicker.month_label}
                                                </Typography>
                                                <div className="booking-slot-picker-nav">
                                                    <button
                                                        type="button"
                                                        className="booking-slot-picker-nav-button"
                                                        onClick={() => bookingPageStore.shiftSlotPickerWindow(-1)}
                                                        disabled={!canShiftBackward || bookingPageStore.loading}
                                                        aria-label="Предыдущие даты"
                                                    >
                                                        <ChevronLeftIcon fontSize="inherit"/>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="booking-slot-picker-nav-button"
                                                        onClick={() => bookingPageStore.shiftSlotPickerWindow(1)}
                                                        disabled={bookingPageStore.loading}
                                                        aria-label="Следующие даты"
                                                    >
                                                        <ChevronRightIcon fontSize="inherit"/>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="booking-slot-picker-dates">
                                                {slotPickerDates.map((dateCard) => (
                                                    <button
                                                        key={dateCard.date}
                                                        type="button"
                                                        className={
                                                            'booking-slot-date-card'
                                                            + (hasSelectedDate && bookingPageStore.selectedDate
                                                                && format(bookingPageStore.selectedDate, 'yyyy-MM-dd') === dateCard.date ? ' active' : '')
                                                            + (isSpecialDate(dateCard) ? ' weekend' : '')
                                                            + (dateCard.is_disabled ? ' disabled' : '')
                                                            + (dateCard.is_today ? ' today' : '')
                                                        }
                                                        onClick={() => bookingPageStore.handleDateChange(dateCard.date)}
                                                        disabled={dateCard.is_disabled || bookingPageStore.loading}
                                                    >
                                                        <span className="booking-slot-date-card-weekday">{dateCard.weekday_short}</span>
                                                        <span className="booking-slot-date-card-day">{dateCard.day_number}</span>
                                                    </button>
                                                ))}
                                            </div>
                                            {bookingPageStore.loading ?
                                                <div className="flex-full-width load-bar">
                                                    <CircularProgress color="secondary" className="loader"/>
                                                </div> : ''}
                                            {hasSelectedDate ? (
                                                <div className="booking-slot-groups">
                                                    {slotPickerGroups.map((group) => (
                                                        group.slots && group.slots.length ? (
                                                            <section key={group.id} className="booking-slot-group">
                                                                <div className="booking-slot-group-title">
                                                                    <span className="booking-slot-group-title-icon">{renderDayPartIcon(group.id)}</span>
                                                                    <span>{group.label}</span>
                                                                </div>
                                                                <div className="booking-slot-group-list">
                                                                    {group.slots.map((slot) => (
                                                                        <button
                                                                            key={`${group.id}-${slot.index}`}
                                                                            type="button"
                                                                            className={
                                                                                'booking-slot-chip'
                                                                                + (isSlotSelected(slot.index) ? ' active' : '')
                                                                                + (slot.busy ? ' busy' : '')
                                                                                + (slot.disabled ? ' disabled' : '')
                                                                                + (slot.is_hot_offer ? ' hot' : '')
                                                                            }
                                                                            onClick={() => bookingPageStore.selectSlotByIndex(slot.index)}
                                                                            disabled={slot.busy || slot.disabled || bookingPageStore.loading}
                                                                        >
                                                                            <span className="booking-slot-chip-time">
                                                                                {slot.time_from}-{slot.time_to}
                                                                            </span>
                                                                            {slot.is_hot_offer ?
                                                                                <WhatshotOutlinedIcon className="booking-slot-chip-hot-icon" fontSize="inherit"/> : null}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            </section>
                                                        ) : null
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="booking-slot-picker-empty">Пожалуйста, выберите дату</div>
                                            )}
                                        </section>
                                        {/* Компонент выбора оборудования */}
                                        {bookingPageStore.resSlotSize && bookingPageStore.resPrice && bookingPageStore.equipments && bookingPageStore.equipments.length > 0 ?
                                            <EquipmentSelection
                                                equipmentData={bookingPageStore.equipments}
                                                selectedEquipment={bookingPageStore.selectedEquipment}
                                                onEquipmentChange={bookingPageStore.setSelectedEquipment}
                                                loading={bookingPageStore.equipmentLoading}
                                                slotCount={bookingPageStore.slotCount}
                                            />
                                            : null}
                                        {bookingPageStore.resSlotSize && bookingPageStore.resPrice ?
                                            <div className="booking-slot-result">
                                                <div className="order-info-title">Информация по заказу:</div>
                                                <div className="flex-full-width font-09em">
                                                    <div className="width-50">
                                                        {selectedDateLabel}
                                                    </div>
                                                </div>
                                                <div className="flex-full-width font-09em">
                                                    <div className="width-50">Время
                                                    </div>
                                                    <div>{bookingPageStore.selectedFrom} — {bookingPageStore.selectedTo}</div>
                                                </div>
                                                <div className="flex-full-width font-09em"/>
                                                {bookingPageStore.price > 0 ?
                                                    <div className="flex-full-width font-09em">
                                                        <div className="width-50">Стоимость</div>
                                                        <div>{bookingPageStore.resPrice}р.</div>
                                                    </div>
                                                    : ''}
                                                {bookingPageStore.discount > 0 ?
                                                    <div className="flex-full-width font-09em">
                                                        <div className="width-50">Скидка</div>
                                                        <div>{bookingPageStore.discount}р.</div>
                                                    </div>
                                                    : ''
                                                }
                                                {/* Детализированная стоимость оборудования */}
                                                {bookingPageStore.equipmentTotalPrice > 0 ?
                                                        <div className="flex-full-width font-09em equipment-total-row">
                                                            <div className="width-50">Доп. оборудование</div>
                                                            <div>{bookingPageStore.equipmentTotalPrice}р.</div>
                                                        </div>
                                                    : ''
                                                }
                                                {/* Детализированная стоимость оборудования */}
                                                {bookingPageStore.equipmentDetailedPrice.length > 0 ?
                                                    bookingPageStore.equipmentDetailedPrice.map(item => (
                                                        <div key={item.id} className="flex-full-width font-09em equipment-detail-row">
                                                            <div className="width-75">
                                                                {item.name} × {item.quantity}
                                                            </div>
                                                            <div>{item.total}р.</div>
                                                        </div>
                                                    ))
                                                    : null
                                                }
                                                <div className="order-result-sum">
                                                    <div className="width-50">Итого</div>
                                                    <div>{(bookingPageStore.resPrice - bookingPageStore.discount) + bookingPageStore.equipmentTotalPrice}р.</div>
                                                </div>
                                            </div>
                                            : ''}


                                        {bookingPageStore.checkBookingAuth() ?
                                            <Grid container spacing={2} className="user-info-fields">
                                                <Grid item xs={12} md={6}>
                                                    <FormControl className="hide-border input-grey margin-top-1_5em full-width">
                                                        <TextField
                                                            placeholder="Ваше имя"
                                                            onChange={bookingPageStore.handleOnChange.bind(this, 'user_name')}
                                                            value={bookingPageStore.user_name}
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <FormControl className="hide-border input-grey margin-top-1_5em full-width">
                                                        <MaterialUiPhoneNumber
                                                            placeholder="Номер телефона"
                                                            defaultCountry={'ru'}
                                                            variant="outlined"
                                                            onChange={bookingPageStore.handleOnChange.bind(this, 'phone')}
                                                            value={bookingPageStore.phone}
                                                            fullWidth
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            : <div className="auth-booking-block">
                                                {bookingPageStore._authStore.loading ?
                                                    <div className="register-loading">
                                                        <CircularProgress color="secondary" className="loader"/>
                                                    </div>
                                                    : ''
                                                }
                                                <div className="title-block">Забронировать можно после авторизации.
                                                </div>
                                                <AuthButtonsBlock authStore={bookingPageStore._authStore}/>
                                            </div>
                                        }
                                        <Button variant="contained"
                                                onClick={bookingPageStore.setOrderCallback}
                                                disabled={bookingPageStore.buttonDisabled || bookingPageStore.loading}
                                                color="secondary"
                                                className={'order-button' + (bookingPageStore.buttonDisabled ? '' : ' enabled')}
                                        >
                                            {
                                                bookingPageStore.requestSend ?
                                                    <CircularProgress color="secondary" className="button-loader"/>
                                                    :
                                                    bookingPageStore.has_google_sync ? 'Забронировать' : 'Отправить запрос'
                                            }
                                        </Button>
                                        <FormControl className="flex-full-width margin-top-1_5em">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        className={bookingPageStore.bookingServiceType === 'muztorg' ? 'blue-checkbox' : ''}
                                                        checked={bookingPageStore.rules_check}
                                                        onChange={bookingPageStore.handleOnChange.bind(this, 'rules_check')}
                                                        value="primary"
                                                        inputProps={{'aria-label': 'primary checkbox'}}
                                                    />
                                                }
                                                label={<span>Я согласен(а) с {bookingPageStore.bookingRules ?
                                                    <button onClick={bookingPageStore.handleModal}
                                                            className="tonesky-font-color rules-link-modal">правилами</button> : 'правилами'} студии</span>}
                                            />
                                        </FormControl>
                                        <SnackBarAlert
                                            open={bookingPageStore.openAlert}
                                            handleClose={bookingPageStore.handleClose}
                                            message={bookingPageStore.alertMessage}
                                            messageType={bookingPageStore.alertMessageType}
                                        />
                                        <SmsModal
                                            visible={bookingPageStore.show_sms_code_modal}
                                            smsCode={bookingPageStore.sms_code}
                                            onSubmitHandler={bookingPageStore.setOrderCallback}
                                            handleChangeCode={bookingPageStore.handleOnChange.bind(this, 'sms_code')}
                                        />
                                        <Modal
                                            aria-labelledby="spring-modal-title"
                                            aria-describedby="spring-modal-description"
                                            open={bookingPageStore.openModal}
                                            onClose={bookingPageStore.handleModal}
                                            closeAfterTransition
                                            className="booking-rules-modal"
                                            // BackdropComponent={Backdrop}
                                            BackdropProps={{
                                                timeout: 500,
                                            }}
                                        >
                                            <Fade in={bookingPageStore.openModal}
                                                  className="booking-rules-modal-body">
                                                <div>
                                                    <h2 id="spring-modal-title">Правила студии</h2>
                                                    <p id="spring-modal-description">{bookingPageStore.bookingRules}</p>
                                                </div>
                                            </Fade>
                                        </Modal>
                                        <BlackListModal
                                            showModal={bookingPageStore.user_is_blocked}
                                        />
                                    </div>
                                </div>
                            </div>
                            : <BookingNotAvailable phone={bookingPageStore.room.studio_phone}/>
                        }
                    </div>
                }
            </Container>
    );
}));
export default BookingRoomPageIndex;
